import { Injectable } from '@angular/core';
import { base } from './base-service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends base {
  constructor(private httpClient: HttpClient) {
    super();
  }
  getLoginHistory(year: any,id:any) {
    return this.httpClient.get(this.serverUrl + 'access-control/loginHistory/' + year+"/"+id, this.httpHeaders);
  }
  getLoginSignUpData(org_id: any) {
    return this.httpClient.get(this.serverUrl + 'access-control/userReportData/' + org_id, this.httpHeaders);
  }
}

